import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute } from "@angular/router";
import { map, Observable, startWith } from "rxjs";
import { default as _rollupMoment, Moment } from "moment";
import * as _moment from "moment";
import { ConfirmComponent } from "src/app/components/dialog/confirm/confirm.component";
import { IConfirmDialogData } from "src/app/components/dialog/dialog.data";
import { ValidationService } from "src/app/services/validation.service";
import { environment } from "src/environments/environment";
import { Colors } from "src/app/assets/strings/colors";
import { ApiCallService } from "../../../api/service/api-call.service";
import * as Constants from "../../../constant/Constants";

const moment = _rollupMoment || _moment;

@Component({
  selector: "app-quote-details",
  templateUrl: "./quote-details.component.html",
  styleUrls: ["./quote-details.component.css"],
})
export class QuoteDetailsUGComponent implements OnInit {

  // Url Params
  insurance: string = "private"; // private, commercial ... etc.
  token: string = "placeholder-value"; // to validate the public accesses.
  // +++++++++++


  VehicleMakePlaceHolders: any = [];
  VehicleModelPlaceHolders: any = [];

  genericDialogData: IConfirmDialogData = {
    title: '',
    content: '',
    cancelButtonText: '',
    confirmButtonText: ''
  };

  VehicleBodyTypePlaceHolders: any = [
    "BUS",
    "CABROLET",
    "CAMPER VAN",
    "COUPE",
    "CROSSOVER",
    "HARDBODY PICKUP",
    "HATCHBACK",
    "HIGH SIDED LORRY",
    "LIFTBACK",
    "LIMOUSINE",
    "LORRY",
    "LOW SIDED LORRY",
    "MICRO",
    "MINI BUS",
    "MINI VAN",
    "MOTOR CYCLE",
    "PICKUP",
    "PICKUP DOUBLE CAB",
    "PRIME MOVER",
    "ROADSTER",
    "SALOON",
    "SEDAN",
    "SPORT CAR",
    "SUV",
    "STATION WAGON",
    "TARGA",
    "TBA",
    "TIPPER",
    "TRACTOR",
    "TRAILER",
    "TRUCK",
    "UNIVERSAL",
    "VAN",
  ];

  
  pageHeading: string = "Private Vehicle Motor Insurance Application";
  pageSubheading: string = "Vehicle Details";

  vehicleRegLabel: string = "Enter vehicle's registration";
  vehicleMakeLabel: string = "Select Vehicle Make";
  vehicleModelLabel: string = "Select Vehicle Model";
  yearManufacturedLabel: string = "Select Year of Manufacture";

  chassisNoLabel: string = "Enter vehicle's chassis number";
  engineNoLabel: string = "Enter vehicle's engine number";
  colourLabel: string = "Enter vehicle's colour";
  seatingCapacityLabel: string = "Enter vehicle's seating capacity";
  ratingCCLabel: string = "Enter vehicle's rating (cc)";
  bodyTypeLabel: string = "Enter vehicle's body type";

  coverStartDateLabel: string = "Cover Start Date";
  coveStartDateDesc: string = "When you would like the cover to start";

  regHint: string = "for example UAA123T";
  colourHint: string = "Start typing for colour suggestions";

  cancel: string = "Cancel";
  saveContinue: string = "Save and Continue";

  minCoverDate: Date;
  maxCoverDate: Date;

  minDate: Date;
  maxDate: Date;

  motorForm = this._formBuilder.group({
    vehicleReg: ["",[Validators.required, Validators.pattern(/^U[A-Za-z]{2}\s?\d{3}[A-Za-z]$/)]],
    vehicleMake: ["", Validators.required],
    vehicleModel: ["", Validators.required],
    yearManufactured: [moment(), Validators.required],
    chassisNo: ["",Validators.required],
    engineNo: ["",Validators.required],
    colour: ["",Validators.required],
    seatingCapacity: ["", [Validators.required, Validators.min(1), Validators.max(9)]],
    ratingCC: ["", [Validators.required, Validators.min(350)]],
    bodyType: ["",Validators.required],
    coverStartDate: [moment(null), Validators.required],

  });

  formErrors:{[key:string]:string} = {
    vehicleReg:'',
    vehicleMake: "",
    vehicleModel: "",
    chassisNo:'',
    engineNo:'',
    colour:'',
    seatingCapacity:'',
    ratingCC:'',
    bodyType:'',
    coverStartDate: '',
  }
  validationMessages:{[key:string]:{[key:string]:string}} = {
    vehicleReg:{required: 'vehicle registration is required', pattern: 'Invalid Vehicle Registration number'},
    vehicleMake: { required: 'This field is required' },
    vehicleModel: { required: 'This field is required' },
    chassisNo:{required:'This field is required'},
    engineNo:{required:'This field  is required'},
    colour:{required:'This field  is required'},
    seatingCapacity:{required:'This field  is required', min: "Invalid value", max: "Maximum covered seats exceeded" },
    ratingCC:{required:'This field is required', min: "Invalid value"},
    bodyType:{required:'This field is required'},
    coverStartDate: { required: "You have to select a start date for your cover" },
  }

  constructor(
    private route: ActivatedRoute,
    private validationService: ValidationService,
    private _formBuilder: FormBuilder,
    private apiCallService: ApiCallService,
    public dialog: MatDialog
  ) {
    const currentDate = new Date();

    const maxCov = new Date(currentDate.getTime());
    const minCov = new Date(currentDate.getTime());
    const tempDate = new Date(currentDate.getTime());

    tempDate.setFullYear(currentDate.getFullYear() - 15);

    this.minDate = tempDate;
    this.maxDate = currentDate;

    minCov.setFullYear(currentDate.getFullYear());
    maxCov.setFullYear(currentDate.getFullYear() + 1);

    this.minCoverDate = minCov;
    this.maxCoverDate = maxCov;

    this.filteredColors = this.motorForm.controls["colour"].valueChanges.pipe(
      startWith(''),
      map(color => (color ? this._filterColors(color) : [] )),
    );
  }

  Colors: string[] = Colors;
  filteredColors: Observable<string[]>;
  
  loading: boolean = false;

  carMakeIsEmpty: boolean = true;
  carModelsEmpty: boolean = true;
  loadingMake: boolean = false;
  loadingModel: boolean = false;
  bodyDisabled: boolean = false;
  
  ngOnInit(): void {
    this.motorForm.valueChanges.subscribe((form)=>{
      this.logErrors();

      if (form.vehicleReg) {
        this.motorForm.patchValue({
          // First replace: remove strings, 2nd replace: leading zeros
          vehicleReg: form.vehicleReg.replace(/[a-z]/g, (match) => match.toUpperCase())
        }, {emitEvent: false});
      }
      if (form.chassisNo) {
        this.motorForm.patchValue({
          chassisNo: form.chassisNo.replace(/[a-z]/g, (match) => match.toUpperCase())
        }, {emitEvent: false});
      }
      if (form.engineNo) {
        this.motorForm.patchValue({
          engineNo: form.engineNo.replace(/[a-z]/g, (match) => match.toUpperCase())
        }, {emitEvent: false});
      }
      if (form.colour) {
        this.motorForm.patchValue({
          colour: form.colour.replace(/[a-z]/g, (match) => match.toUpperCase())
        }, {emitEvent: false});
      }
      if (form.seatingCapacity) {
        this.motorForm.patchValue({
          seatingCapacity: form.seatingCapacity.replace(/\D/g, '').replace(/^0+/, '')
        }, {emitEvent: false});
      }
      if (form.ratingCC) {
        this.motorForm.patchValue({
          ratingCC: form.ratingCC.replace(/\D/g, '').replace(/^0+/, '')
        }, {emitEvent: false});
      }
      if (form.bodyType) {
        this.motorForm.patchValue({
          bodyType: form.bodyType.replace(/[a-z]/g, (match) => match.toUpperCase())
        }, {emitEvent: false});
      }
      
    })

    this.route.queryParams.subscribe((params) => {
      console.log(params); // log route params
      
      if (params["token"] !== undefined) {
        this.token = params["token"];
      }
      
      // Handle insurance page param
      if (params["insurance"] !== undefined) {
        this.insurance = params["insurance"];

        if (params["insurance"] === "commercial") {
          this.pageHeading = "Commercial Vehicle Motor Insurance Application";
          this.validationService.addOrRemoveSeatingCommercialValidator(true,this.motorForm.get('seatingCapacity')!)
        } else if (params["insurance"] === "motorcycle") {
          this.pageHeading = "Motorcycle Insurance Application";

          this.pageSubheading = "Motorcycle Details";
          this.vehicleRegLabel = "Enter motorcycle registration";
          this.vehicleMakeLabel = "Select Motorcycle Make";
          this.vehicleModelLabel = "Select Motorcycle Model";
          this.chassisNoLabel = "Enter the motorcycle chassis number";
          this.engineNoLabel = "Enter the motorcycle engine number";
          this.colourLabel = "Enter motorcycle colour";
          this.seatingCapacityLabel = "Enter motorcycle seating capacity";
          this.ratingCCLabel = "Enter motorcycle rating (cc)";
          this.bodyTypeLabel = "Enter motorcycle body type";

          this.validationService.addOrRemoveValidatorSMinReq(true, this.motorForm.get('ratingCC')!, 50);
          this.motorForm.get('bodyType')?.setValue('MOTOR CYCLE');
          this.bodyDisabled = true;
        }
      }
    });

    this.getCarMakeList();
  }

  async getCarMakeList() {
    this.loadingMake = true;
    const response = await this.apiCallService.getRequest(
      environment.baseUrl + Constants.vehicleMakeURL
    );

    const isResponseValid = this.checkArrayStringType(response);

    if (isResponseValid) {
      this.VehicleMakePlaceHolders = response;
      this.carMakeIsEmpty = false;
      this.loadingMake = false;
    } else {
      this.loadingMake = false;
    }
    
  }

  async populateCarModelList() {
    this.VehicleModelPlaceHolders = [""];
    this.loadingModel = true;
    
    const carMakeValue = this.motorForm.controls["vehicleMake"].value;

    const vhmodelRequest = {
      carMake: carMakeValue,
    };

    const response = await this.apiCallService.postRequest(
      environment.baseUrl + Constants.vehicleModelURL,
      vhmodelRequest
    );

    const isResponseValid = this.checkArrayStringType(response);

    if (!isResponseValid) {
      this.carModelsEmpty = true;
    } else {
      this.VehicleModelPlaceHolders = response.filter(function(entry: string) { return entry.trim() != ''; }); // Trim empty string entries
      this.carModelsEmpty = false;
    }

    this.loadingModel = false;
  }

  logErrors() {
    this.validationService.logValidationErrors(
      this.motorForm,
      this.formErrors,
      this.validationMessages
  )};

  _filterColors(value: string): string[] {
    const filterValue = value.toLowerCase();
    if (value.length > 1)
      return this.Colors.filter(color => color.toLowerCase().includes(filterValue)).sort(function(a, b){
        return a.length - b.length;
      });
    else 
      return this.Colors.filter(color => color.toLowerCase().includes(filterValue));
  }

  selectedYearHandler(normalizedYear: Moment, dp: any) {
    const ctrlValue = this.motorForm.controls["yearManufactured"].value;

    ctrlValue!.year(normalizedYear.year());
    this.motorForm.controls["yearManufactured"].setValue(ctrlValue);
    dp.close();

    console.log(this.motorForm.controls["yearManufactured"].value, ctrlValue);
  }

  submitForm(): void {
    this.initDialogData(
      'Confirm submission',
      'Please proceed only if you have verified that the form details are correct',
      'Back',
      'Proceed'
    );

    this.showGenericPopup(this.postDataToWhatsapp);
  }

  showGenericPopup(runFunction: ()=> void) {
    const dialogRef = this.dialog.open(ConfirmComponent, {
      disableClose: true,
      data: this.genericDialogData,
    });

    dialogRef.afterClosed().subscribe(result => {
      console.group('Generic Dialog');
      if (result) {
        console.log('dialog confirmed');
        runFunction();
      } else {
        console.log('dialog dismissed');
      }
      console.groupEnd();
    });
  };

  initDialogData(title: string, content: string, cancelButtonText: string, confirmButtonText: string) {
    this.genericDialogData.title = title;
    this.genericDialogData.content = content;
    this.genericDialogData.cancelButtonText = cancelButtonText;
    this.genericDialogData.confirmButtonText = confirmButtonText;
  };

  postDataToWhatsapp = async () => {
    this.loading = true;

    const req = {
      quoteNumber: "1",
      classCode: "970",
      classOfUse: "private",
      typeOfCover: "COMP",
      vehicleReg: this.motorForm.controls["vehicleReg"].value,
      make: this.motorForm.controls["vehicleMake"].value,
      model: this.motorForm.controls["vehicleModel"].value,
      yom: this.motorForm.controls["yearManufactured"].value!.format("YYYY"),
      chassisNo: this.motorForm.controls["chassisNo"].value,
      engineNo: this.motorForm.controls["engineNo"].value,
      colour: this.motorForm.controls["colour"].value,
      seatingCapacity: this.motorForm.controls["seatingCapacity"].value,
      ratingCC: this.motorForm.controls["ratingCC"].value,
      bodyType: this.motorForm.controls["bodyType"].value,
      coverStartDate:
        this.motorForm.controls["coverStartDate"].value!.format(
          "MM-DD-YYYY"
        ),
      token: this.token
    };

    try {
      // Update form data (POST)
      const url = environment.baseUrl + Constants.quoteUG_URL;
      const response = await this.apiCallService.postRequest(
        `${url}?token=${this.token}`, req
      ); // url to change for UG?
      
      console.log(":: Response data ::  ", response);

      if (response.error === false) {
        console.log("::: Post successful :::");
        // Navigate back to Whatsapp chat
        window.location.href = environment.whatsappRedirectURL_UG;
      } else {
        console.log("::: Post failed :::", response.message);
        this.loading = false;

        this.initDialogData(
          'Submission Failed',
          'An error occurred while saving the form details',
          'cancel',
          'TRY AGAIN'
        );

        this.showGenericPopup(this.postDataToWhatsapp);
      }
    } catch (error) {
      console.log('ERROR :: ', error)
      this.loading = false;

      this.initDialogData(
        'Submission Failed',
        'An unexpected error occurred',
        'cancel',
        'TRY AGAIN'
      );
      this.showGenericPopup(this.postDataToWhatsapp);
    } 
  }

  // Validates car lists responses
  checkArrayStringType(value: any) {
    var arrayIsString = true;

    try {
      if (Array.isArray(value)) {
        if (value.length === 0) {
          arrayIsString = false;
        } else {
          value.forEach(function (item) {
            if (typeof item !== "string") {
              arrayIsString = false;
            }
          });
        }

        return arrayIsString;
      } else {
        arrayIsString = false;

        return arrayIsString;
      }
    } catch (error) {
      arrayIsString = false;

      return arrayIsString;
    }
  }

  confirmCancel() {
    this.initDialogData(
      'Warning',
      'Are you sure you want to cancel the application?',
      'back',
      'Cancel application'
    );

    this.showGenericPopup(this.cancelApplication);
  }

  cancelApplication() {
    console.log(":: Cancelling application ...");
    // Send update to chat that form application was cancelled

    // Navigate back to Whatsapp chat
    window.location.href = environment.whatsappRedirectURL_UG;

  }
}
